<template>
    <v-menu v-model="show" :close-on-content-click="false" transition="scale-transition" offset-y>
        <template #activator="{ on, attrs }">
            <v-text-field
                ref="textField"
                dense
                :style="textfieldStyle"
                :outlined="outlined"
                :class="inputClass"
                :clearable="!readOnly && clearable"
                :value="dateString"
                :label="label"
                :placeholder="placeholder"
                :required="required"
                :disabled="disabled"
                :tabindex="tabindex"
                v-bind="{ ...attrs, ...$attrs }"
                @click:append="show = true"
                @change="valueChanged"
                @blur="checkOnBlurValue"
                @keydown.tab="onTab"
                v-on="readOnly ? null : on"
            >
                <template #append>
                    <v-btn icon plain x-small tabindex="-1" :disabled="disabled" @click="show = true">
                        <KpIcon :icon-cls="appendIcon" size="16" color="grey" />
                    </v-btn>
                </template>
            </v-text-field>
        </template>
        <div class="d-flex flex-column">
            <v-date-picker
                ref="picker"
                :value="isoDateStr(dateString)"
                :min="isoDateStr(valueFrom)"
                :max="isoDateStr(valueTo)"
                :disabled="disabled"
                first-day-of-week="1"
                @input="valueChanged"
            />
            <ActionBtn @click="todayBtn">{{ $t('today') }}</ActionBtn>
        </div>
    </v-menu>
</template>

<script>
import dayjs from 'dayjs';
import KpIcon from '../KpIcon.vue';

export default {
    components: { KpIcon },
    props: {
        outlined: {
            type: Boolean,
            default: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        value: {
            type: dayjs,
            default: null,
        },
        valueFrom: {
            type: String,
            default: null,
        },
        valueTo: {
            type: String,
            default: null,
        },
        inputClass: {
            type: [String, Object],
            default: null,
        },
        appendIcon: {
            type: String,
            default: 'ic ic-16 ic-calendar ic-col-grey',
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        textfieldStyle: {
            type: [String, Object],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            show: false,
            dateString: null,
        };
    },
    watch: {
        value(newVal, oldVal) {
            if (newVal !== oldVal && !newVal?.isSame(oldVal)) {
                this.handleValueProp(newVal);
            }
        },
    },
    mounted() {
        this.handleValueProp(this.value);
    },
    methods: {
        handleValueProp(val) {
            if (val && typeof val === 'string') {
                val = dayjs(val);
            }
            if (val instanceof dayjs) {
                if (val.isValid()) {
                    this.dateString = val.formatIf('DD.MM.YYYY');
                    this.$emit('input', val);
                    return;
                }
            }
            this.dateString = null;
        },
        parseDate(
            input,
            validInputDates = [
                'DD.MM.YYYY',
                'D.M.YY',
                'DD.M.YY',
                'D.MM.YY',
                'D.M.YYYY',
                'DD.M.YYYY',
                'D.MM.YYYY',
                'YYYY-MM-DD',
            ],
        ) {
            if (input && !(input instanceof dayjs)) {
                input = dayjs(input, validInputDates, true);
            }
            if (input instanceof dayjs && input.isValid()) {
                return input;
            } else {
                return null;
            }
        },
        valueChanged(value) {
            let d = this.parseDate(value);
            if (d) {
                this.dateString = d.formatIf('DD.MM.YYYY');
                this.$emit('input', d);
            } else {
                this.dateString = null;
            }
            this.show = false;
        },
        checkOnBlurValue(ev) {
            // This is intentional: this allows to get other events handled, before
            // the blur occurs, e.g. the "now"-btn handler:
            setTimeout(() => {
                let d = this.parseDate(this.dateString, ['DD.MM.YYYY', 'YYYY-MM-DD', 'DD.MM.']);
                if (d && d.isValid()) {
                    this.$emit('input', d);
                } else {
                    this.$emit('input', null);
                }
            }, 100);
            // if (!this.$refs.picker.$el.contains(ev.relatedTarget)) {
            // this.focus = false;
            // this.show = false;
            // }
        },
        isoDateStr(strOrDayJs) {
            let d = this.parseDate(strOrDayJs);
            if (d) {
                return d.formatIf('YYYY-MM-DD');
            }
            return '';
        },
        todayBtn() {
            this.valueChanged(dayjs().formatIf('YYYY-MM-DD'));
        },
        onTab() {
            this.show = false;
        },
        focus() {
            setTimeout(() => {
                this.$refs.textField.$el.querySelector('input').focus();
            }, 50);
        },
    },
};
</script>
